<template>
  <BaseButton ghost small @click="open">
    <span class="truncate"> Delete </span>
  </BaseButton>
</template>

<script>
import { tagsClient } from '@/api/clients';

export default {
  props: {
    tag: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('Components/Tags/TagDeleteModal.vue'),
        props: {
          action: tagsClient.destroy,
          tag: this.tag,
        },
        on: {
          'tag-deleted': (tag) => {
            this.$emit('tag-deleted', tag);
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
